// generated by genversion
export var version = '4.5.0';
//# sourceMappingURL=version.js.map